import {generatePath} from "react-router";

export const generateAbsolutePath = (
    pattern: string,
    params?: { [paramName: string]: string | number | boolean | undefined }
) => process.env.REACT_APP_BASE_PATH + generatePath((pattern.startsWith('/') ? pattern : '/' + pattern), params)

